module.exports = __webpack_public_path__ + "static/media/testimg.82093552.jpg";